import { Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { ApiAmaxPayPaymentDetailsVerificationStatus } from 'shared/data/webApp/v2';

import { messages } from './VerifyStatus.messages';
import { VerifyStatusProps } from './VerifyStatus.types';

export const VerifyStatus = memo<VerifyStatusProps>((props) => {
    const { status, isError } = props;

    if (isError) {
        return (
            <Text color='red100' font='label' fontSize='small' fontWeight='bold'>
                {messages.serviceNotAvailable}
            </Text>
        );
    }

    switch (status) {
        case ApiAmaxPayPaymentDetailsVerificationStatus.full_match:
            return (
                <Text color='green100' font='label' fontSize='small' fontWeight='bold' uppercase>
                    {messages.fullMatch}
                </Text>
            );

        case ApiAmaxPayPaymentDetailsVerificationStatus.close_match:
            return (
                <Text color='brandDext90' font='label' fontSize='small' fontWeight='bold' uppercase>
                    {messages.closeMatch}
                </Text>
            );

        case ApiAmaxPayPaymentDetailsVerificationStatus.no_match:
            return (
                <Text color='red100' font='label' fontSize='small' fontWeight='bold' uppercase>
                    {messages.noMatch}
                </Text>
            );

        default:
            return (
                <Text color='midnight100' font='label' fontSize='small'>
                    {messages.fillDetails}
                </Text>
            );
    }
});

VerifyStatus.displayName = 'VerifyStatus';
